import { FOOTER } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'footer_3',
  type: FOOTER,
  name: 'Footer 3',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/footer/footer_3.jpg',
  rootContent: {
    type: contentTypes.SIMPLE_FOOTER,
    properties: {
      minHeight: {type: 'css', value: '6.5rem', editable: false},
      backgroundColor: {type: 'css', value: '#000',editable: true},
      color: {type: 'css', value: '#586f66', editable: true},
      padding: {type: 'css', value: '1.5rem 0rem'},
      fontSize: {type: 'css', value: '14px'},
      fontWeight: {type: 'css', value: 'bold'},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '1rem'},
      socialMedia: {type: 'custom', value: false, editable: true},
      facebookLink: {type: 'custom', value: 'facebook.com', editable: true},
      socialMediaIconColor: {type: 'custom', value: '#313131', editable: true},
      socialMediaIconSize: {type: 'custom', value: '1.5rem', editable: true},
    },
    contents: []
  }
}
